module.exports = __webpack_public_path__ + "img/iphone-charging-GERMANY-en.6e8dcb15.png";